import _ from 'lodash';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { filter, map, Observable, Subject, takeUntil } from 'rxjs';
import { selectDialogState } from 'app/dialog/features/dialog.selectors';
import { select, Store } from '@ngrx/store';
import { DialogService } from 'app/dialog/services/dialog.service';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-copy-event-dialog',
  templateUrl: './copy-event-dialog.component.html',
  styleUrl: './copy-event-dialog.component.scss'
})
export class CopyEventDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  public dialog$: Observable<any> = this.store.pipe(select(selectDialogState));
  public selectedEvent = null;

  public eventId = null;
  public event = null;
  public modalTitle = null;
  public modalSubtitle = null;
  public inputLabel = null;
  public newName = new UntypedFormControl();
  public startDateTimeGmtUnix = new UntypedFormControl();
  public duration = new UntypedFormControl();
  public timeZoneData: UntypedFormGroup;
  public name = new UntypedFormControl();
  public takeUntilSubject = new Subject();
  public timeZoneList = [];
  public submitted = false;


  constructor(
    private store: Store,
    private dialogService: DialogService,
    private formBuilder: UntypedFormBuilder
  ) { }


  ngOnInit(): void {

    this.timeZoneData = this.formBuilder.group({
      name: [moment.tz.guess(), Validators.required],
      abbr: [this.getStartAbbr(), Validators.required],
      offset: [this.getStartOffset(), Validators.required],
    });
    this.duration.setValidators([Validators.required, Validators.min(1),Validators.max(1440) ])

    this.dialog$.pipe(
      takeUntil(this.takeUntilSubject)
    ).subscribe((value)=>{
      if(value.initialState.event){

        this.event = value.initialState.event;
        switch(this.event.type) {
          case 0:
              this.eventId = this.event.inPersonEventInfo.id;
              this.modalTitle ='Copy In-person Event';
              this.modalSubtitle = `Copy <b>${this.event.inPersonEventInfo.name}</b> to create new.`
              this.inputLabel = 'New In-person Event Name'
              break;
          case 1:
              this.eventId  = this.event.virtualEventInfo.id;
              this.modalTitle = 'Copy Virtual Event';
              this.modalSubtitle = `Copy <b>${this.event.virtualEventInfo.name}</b> to create new.`
              this.inputLabel = 'New Virtual Event Name'
              break;
          case 2:
              this.eventId  = this.event.hybridEventInfo.id;
              this.modalTitle = 'Copy Hybrid Event';
              this.modalSubtitle = `Copy <b>${this.event.hybridEventInfo.name}</b> to create new.`
              this.inputLabel = 'New Hybrid Event Name'
              break;
        }

        const timestamp = this.startDateTimeGmtUnix.value * 1000;
        const zones = moment.tz.names();
        this.timeZoneList = _.chain(zones).map((name, index) => {
          const offset = moment.tz.zone(name).utcOffset(timestamp);
          const gmt = `GMT ${moment.tz(timestamp, name).format('Z')}`;
          let abbr = moment.tz(timestamp, name).format('z');
          if(abbr.match(/[\+\-][0-9]+/) !== null) {
            abbr = gmt;
          }
          const label = `(${gmt}) ${name} - ${abbr}`;
          return { index, label, value: name, offset };
        }).sortBy('offset').value();
    
        const timeZoneData = this.timeZoneData;
        timeZoneData.get('name').valueChanges.pipe(
          filter(value => !_.isNull(value)),
          takeUntil(this.takeUntilSubject)
        ).subscribe(value => {
          const zone = moment.tz.zone(value);
          const abbrControl = timeZoneData.get('abbr');
    
          const timestamp = this.startDateTimeGmtUnix.value * 1000;
          const abbr = zone.abbr(timestamp);
    
          abbrControl.setValue(abbr);
        });

        timeZoneData.get('abbr').valueChanges.pipe(
          filter(value => !_.isNull(value)),
          takeUntil(this.takeUntilSubject)
        ).subscribe(abbr => {
          const abbrControl = timeZoneData.get('abbr');
          const nameControl = timeZoneData.get('name');
          const offsetControl = timeZoneData.get('offset');
    
          const zone = moment.tz.zone(nameControl.value);
    
          const index = _.findIndex(zone.abbrs, value => _.isEqual(value, abbr));
          const offset = zone.offsets[index] * -60;
    
          offsetControl.setValue(offset);
    
          const matches = abbr.match(/[\+\-][0-9]+/);
          const abbrValue = _.isArray(matches) ? `GMT ${matches[0]}`: abbr;
          
          abbrControl.setValue(abbrValue, { emitEvent: false });
        });
    
        this.startDateTimeGmtUnix.valueChanges.pipe(
          filter(value => !_.isNull(value)),
          filter(() => {
            const nameControl = timeZoneData.get('name');
            return !_.isNull(nameControl.value)
          }),
          filter(() => {
            const abbrControl = timeZoneData.get('abbr');
            return !_.isNull(abbrControl.value)
          }),
          map(value => value * 1000),
          takeUntil(this.takeUntilSubject)
        ).subscribe(value => {
          const nameControl = timeZoneData.get('name');
          const abbrControl = timeZoneData.get('abbr');
          const zone = moment.tz.zone(nameControl.value);
          const abbr = zone.abbr(value);
          abbrControl.setValue(abbr);
    
          const timestamp = this.startDateTimeGmtUnix.value * 1000;
          const zones = moment.tz.names();
          this.timeZoneList = _.chain(zones).map((name, index) => {
            const offset = moment.tz.zone(name).utcOffset(timestamp);
            const gmt = `GMT ${moment.tz(timestamp, name).format('Z')}`;
            let abbr = moment.tz(timestamp, name).format('z');
            if(abbr.match(/[\+\-][0-9]+/) !== null) {
              abbr = gmt;
            }
            const label = `(${gmt}) ${name} - ${abbr}`;
            return { index, label, value: name, offset };
          }).sortBy('offset').value();
        });
    
        this.startDateTimeGmtUnix.valueChanges.pipe(
          takeUntil(this.takeUntilSubject)
        ).subscribe((value) => { });
      }
    })
   }   

  ngAfterViewInit(): void {
    this.newName.valueChanges.pipe(
      filter(value => value !== null),
      takeUntil(this.takeUntilSubject)
    ).subscribe((value)=>{
    })
   }

  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
    try {
      this.dialogService.modalRef.close();
      this.dialogService.closeDialogSubject.next(null);
    } catch(e) {}
  }

  validate(){
    if(!this.newName.value){
      this.newName.markAsTouched();
      this.newName.setErrors({'incorrect': true})
      return false
    }

    if(!this.startDateTimeGmtUnix.value){
      this.startDateTimeGmtUnix.markAsTouched();
      this.startDateTimeGmtUnix.setErrors({'incorrect': true})
      this.submitted = true;
      return false
    }

    if(!this.duration.value){
      this.duration.markAsTouched();
      this.duration.setErrors({'incorrect': true})
      return false
    }

    return true;
  }

  onCopyClick(dialog){
    if(this.validate()){
      const { initialState: { action, callback } } = dialog;
      callback(this.getParams())
      this.close(dialog, false)
    }
  }

  getParams(){
    let param = {}
    switch(this.event.type) {
      case 0:
          param['inPersonEventId'] = this.event.inPersonEventInfo.id;
          break;
      case 1:
          param['virtuelEventId'] = this.event.virtualEventInfo.id;
          break;
      case 2:
          param['hybridEventId'] = this.event.hybridEventInfo.id;
          break
    }

    param['name'] = this.newName.value;
    param['startDateTimeGmtUnix'] = this.startDateTimeGmtUnix.value;
    param['duration'] = this.duration.value;
    param['timeZone'] = this.timeZoneData.value.offset;
    param['timeZoneAbbr'] = this.timeZoneData.value.abbr;
    param['timeZoneData'] = this.timeZoneData.value;

    return param;
  }

  getStartAbbr(){
    const guess = moment.tz.guess();
    const zone = moment.tz.zone(guess);
    const timestamp = (new Date()).getTime();
    return zone.abbr(timestamp);
  }

  getStartOffset(){
    const guess = moment.tz.guess();
    const zone = moment.tz.zone(guess);
    const timestamp = (new Date()).getTime();
    const abbr = zone.abbr(timestamp);
    const index = _.findIndex(zone.abbrs, (value) => _.isEqual(value, abbr));
    return zone.offsets[index] * -60;
  }

  close(dialog, value) {
    try {
      this.dialogService.modalRef.close();
      this.dialogService.closeDialogSubject.next(value);
    } catch(e) {}

    const { initialState: { action, callback } } = dialog;
    if(value) {
      if(action) {
        this.store.dispatch(action);
      }
    }
    callback(value);
  }
}
